export default "__VITE_ASSET__C4n0B6Ry__"